import { render, staticRenderFns } from "./editdorm-info.vue?vue&type=template&id=327351c4&scoped=true"
import script from "./editdorm-info.vue?vue&type=script&lang=js"
export * from "./editdorm-info.vue?vue&type=script&lang=js"
import style0 from "./editdorm-info.vue?vue&type=style&index=0&id=327351c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327351c4",
  null
  
)

export default component.exports